/**
 * Copyright (c) 2025 eBUCIS, LLC. All rights reserved.
 *
 * Coach Dashboard Page - Dedicated page for coach-specific functionality
 * Accessible at /coach route for users with isCoach flag
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

import { useAuthStore } from '../stores/authStore'
import { Navigate } from 'react-router-dom'
import CoachDashboard from '../components/CoachDashboard'

const CoachDashboardPage = () => {
  const { user, isLoading } = useAuthStore()

  // If user is not a coach, redirect to main dashboard
  if (!isLoading && user && !user.isCoach) {
    return <Navigate to="/dashboard" replace />
  }

  return <CoachDashboard />
}

export default CoachDashboardPage
